export const WarningIcon = () => (
  <svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="48" cy="48" r="44" stroke="#FFBEBE" strokeWidth="2" strokeDasharray="6 4"/>
    <path d="M48 22L74 66H22L48 22Z" stroke="#FF4444" strokeWidth="2.5" strokeLinejoin="round" fill="none"/>
    <line x1="48" y1="37" x2="48" y2="53" stroke="#FF4444" strokeWidth="3" strokeLinecap="round"/>
    <circle cx="48" cy="59" r="2.5" fill="#FF4444"/>
  </svg>
);
